import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingPageGuard, LandingPageMetaGuard } from './guards';

import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import * as fromStore from './store';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./containers/landing-page/landing-page.component').then(m => m.LandingPageComponent),
        data: {
          slug: 'home',
        },
        canActivate: [LandingPageGuard, LandingPageMetaGuard],
      },
      {
        path: ':slug',
        loadComponent: () => import('./containers/landing-page/landing-page.component').then(m => m.LandingPageComponent),
        canActivate: [LandingPageGuard, LandingPageMetaGuard],
      },
    ],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
